import { common } from './common.icons';

export const IconShieldCheck = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-shield-check ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 16 16"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
    >
      <path d="M5.99706 7.99891L7.33026 9.33229L9.99666 6.66554M13.3297 8.6659C13.3297 11.9993 10.9966 13.6661 8.22351 14.6328C8.0783 14.682 7.92056 14.6796 7.77688 14.6261C4.99716 13.6661 2.66406 11.9993 2.66406 8.6659V3.99908C2.66406 3.82227 2.73429 3.65269 2.85931 3.52766C2.98432 3.40264 3.15387 3.3324 3.33066 3.3324C4.66386 3.3324 6.33036 2.53237 7.49025 1.519C7.63147 1.39833 7.81112 1.33203 7.99686 1.33203C8.18261 1.33203 8.36226 1.39833 8.50348 1.519C9.67003 2.53904 11.3299 3.3324 12.6631 3.3324C12.8399 3.3324 13.0094 3.40264 13.1344 3.52766C13.2594 3.65269 13.3297 3.82227 13.3297 3.99908V8.6659Z" />
    </svg>
  );
};
